// app.js
import Vue from 'vue';
import App from './App.vue';
import { createRouter, } from './router/index';
import { createStore, } from './store/index';
import { sync, } from 'vuex-router-sync';
import VueLink from './components/VueLink/VueLink';
import VueImg from './components/VueImg/VueImg';
import VueScroll from './components/VueScroll/VueScroll';
import Sidebar from './components/Sidebar/Sidebar';
// import Toast from './Vux/components/toast/index';
import titleMixin from './util/title';
import updateView from './util/updateView';
import $http from './plug/$http/$http';
import netFailure from './components/netFailure/netFailure';
import bottomFixedBlank from './components/bottomFixedBlank/bottomFixedBlank';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.component('vue-link', VueLink);
Vue.component('vue-img', VueImg);
Vue.component('vue-scroll', VueScroll);
Vue.component('vue-sidebar', Sidebar);
// Vue.component('toast', Toast);
Vue.component('net-failure', netFailure);
Vue.component('bottom-fixed-blank', bottomFixedBlank);
Vue.mixin(titleMixin);
Vue.mixin(updateView);
Vue.use($http);

export function createApp () {
  // 创建 router 实例
  const router = createRouter();
  const store = createStore();
  // 同步路由状态(route state)到 store
  sync(store, router);
  const app = new Vue({
    // 注入 router 到根 Vue 实例
    router,
    store,
    render: h => h(App),
    el: '#app',
  });
    // 返回 app 和 router
  return { app, router, store, };
}



// WEBPACK FOOTER //
// src/app.js